module.exports = __webpack_public_path__ + "static/media/chart_gif3.eea6904e.gif";